<template>
  <v-container fluid>
    <v-card class="pa-6">
      <v-row align="center" class="mb-6">
        <v-col>
          <div class="text-h5 font-weight-bold">+ New Matter Data Sheet</div>
          <div class="caption grey--text">
            เพิ่มแบบฟอร์มสรุปข้อมูลลูกค้า — กรุณาเลือกประเภทลูกค้าก่อน
          </div>
        </v-col>
        <v-col class="d-flex justify-end">
          <v-btn outlined @click="$router.back()">
            <v-icon left>mdi-arrow-left</v-icon>ย้อนกลับ
          </v-btn>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12" md="6">
          <v-card outlined class="pa-6">
            <div class="d-flex align-center mb-2">
              <span style="font-size:20px" class="mr-2">🏢</span>
              <span class="text-subtitle-1 font-weight-bold"
                >เลือกประเภทลูกค้า | Entity Type</span
              >
            </div>
            <div class="caption grey--text mb-4">
              5 ประเภทที่เลือกได้ —
              ระบบจะแสดงฟอร์มที่ตรงกับประเภทที่เลือกเท่านั้น
            </div>

            <div
              v-for="entity in entityTypes"
              :key="entity.value"
              class="entity-option mb-2"
              @click="selectEntityType(entity.value)"
            >
              <span class="entity-icon mr-3" style="font-size:22px;">{{
                entity.icon
              }}</span>
              <div class="flex-grow-1">
                <div class="font-weight-medium" style="font-size:14px;">
                  {{ entity.name }}
                </div>
                <div class="caption grey--text">{{ entity.nameTh }}</div>
              </div>
              <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import { server } from "@/services/constants";

export default {
  name: "incorporate-matter-entity-select",
  data() {
    return {
      entityTypes: [
        {
          value: "Limited Company",
          name: "Limited Company",
          nameTh: "บริษัทจำกัด",
          icon: "🏭",
        },
        {
          value: "Public Company Limited",
          name: "Public Company Limited",
          nameTh: "บริษัทมหาชนจำกัด",
          icon: "🏦",
        },
        {
          value: "Foundation",
          name: "Foundation",
          nameTh: "มูลนิธิ",
          icon: "❤️",
        },
        {
          value: "Representative Office",
          name: "Representative Office",
          nameTh: "สำนักงานผู้แทนการค้า",
          icon: "🌐",
        },
        {
          value: "Individual",
          name: "Individual",
          nameTh: "บุคคลธรรมดา",
          icon: "👤",
        },
      ],
    };
  },
  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
  async mounted() {
    this.$hideLoader();
  },
  methods: {
    selectEntityType(entityType) {
      this.$router.push(
        `/incorporate-matter-add/${encodeURIComponent(entityType)}`,
      );
    },
  },
};
</script>

<style scoped>
.entity-option {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border: 1.5px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
  background: #fff;
}
.entity-option:hover {
  border-color: #0a7ea5;
  background: #f0f9ff;
}
</style>
